import React from 'react';
import { makeStyles, createStyles, Grid } from '@material-ui/core';

import { PageLocation } from '../../../../shared/enum/PageLocation';
import { HomeContext } from '../../../Home/HomeContext';
import { FilterClassificationModel, filterClassificationModelInitial } from '../../../../Models/FilterClassificationModel';
import { RevisionContext } from '../RevisionContext';
import { ReportRevision } from './ReportRevision';
import { BatchCorrection } from './BatchCorrection';
import { IInformationToCorrect } from '../enum/InformationToCorrect';
import { SearchStatus } from '../../../../shared/enum/SearchStatus';

const useStyles = makeStyles(() => createStyles({
    gridContainer: {
        maxWidth: '1152px',
        margin: 0
    },
}));
 
export function Revision() {
    const classes = useStyles();    

    const homeContext = React.useContext(HomeContext);

    const [filterClassification, setFilterClassification] = React.useState<FilterClassificationModel>(filterClassificationModelInitial);
    const [informationToCorrect, setInformationToCorrect] = React.useState<IInformationToCorrect | null>(null);
    const [clientName, setClientName] = React.useState<string>('');
    const [ids, setIds] = React.useState<number[]>([]);
    const [spotlightBatchOpenDialog, setSpotlightBatchOpenDialog] = React.useState<boolean>(false);
    const [contentBatchOpenDialog, setContentBatchOpenDialog] = React.useState<boolean>(false);
    const [extraParametersBatchOpenDialog, setExtraParametersBatchOpenDialog] = React.useState<boolean>(false);
    const [sourceBatchOpenDialog, setSourceBatchOpenDialog] = React.useState<boolean>(false);
    const [journalistBatchOpenDialog, setJournalistBatchOpenDialog] = React.useState<boolean>(false);
    const [keywordBatchOpenDialog, setKeywordBatchOpenDialog] = React.useState<boolean>(false);
    const [coverPresenceBatchOpenDialog, setCoverPresenceBatchOpenDialog] = React.useState<boolean>(false);
    const [locationBatchOpenDialog, setLocationBatchOpenDialog] = React.useState<boolean>(false);
    const [vehicleBatchOpenDialog, setVehicleBatchOpenDialog] = React.useState<boolean>(false);
    const [organogramBatchOpenDialog, setOrganogramBatchOpenDialog] = React.useState<boolean>(false);
    const [expositionBatchOpenDialog, setExpositionBatchOpenDialog] = React.useState<boolean>(false);
    const [searchStatus, setSearchStatus] = React.useState<SearchStatus>(SearchStatus.INITIAL);
    const [mediaId, setMediaId] = React.useState<number>(0);

    React.useEffect(() => {
        setFilterClassification(filterClassificationModelInitial);
        setSearchStatus(SearchStatus.INITIAL);
        setInformationToCorrect(null);
    }, [homeContext.pageLocation]);
    
    return (
        <RevisionContext.Provider value={{
            filterClassification, setFilterClassification,
            informationToCorrect, setInformationToCorrect,
            clientName, setClientName,
            ids, setIds, 
            spotlightBatchOpenDialog, setSpotlightBatchOpenDialog,
            contentBatchOpenDialog, setContentBatchOpenDialog,
            extraParametersBatchOpenDialog, setExtraParametersBatchOpenDialog,
            coverPresenceBatchOpenDialog, setCoverPresenceBatchOpenDialog,
            sourceBatchOpenDialog, setSourceBatchOpenDialog,
            journalistBatchOpenDialog, setJournalistBatchOpenDialog,
            keywordBatchOpenDialog, setKeywordBatchOpenDialog,
            locationBatchOpenDialog, setLocationBatchOpenDialog,
            vehicleBatchOpenDialog, setVehicleBatchOpenDialog,
            organogramBatchOpenDialog, setOrganogramBatchOpenDialog,
            expositionBatchOpenDialog, setExpositionBatchOpenDialog,
            searchStatus, setSearchStatus,
            mediaId, setMediaId}} >
            <Grid container justify="center" alignItems="center">
                <Grid container justify="center" className={classes.gridContainer} spacing={2}>   
                    {homeContext.pageLocation === PageLocation.REPORT_REVISION && <ReportRevision /> }
                    {homeContext.pageLocation === PageLocation.BATCH_CORRECTION && <BatchCorrection /> }
                </Grid>
            </Grid>
        </RevisionContext.Provider>
    );
}